import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { getAgentsAsync } from "redux/actions/employeeManagement.action";
import {
  IAgent,
  IEmployeeManagementResponse,
} from "models/Employee/employeeManagement.model";
import { IEmployeeManagementState } from "models/Slices/employeeManagementSlice.model";

const initialState: IEmployeeManagementState = {
  agents: null,
  loading: false,
  error: "",
  success: false,
};

export const employeeManagementSlice = createSlice({
  name: "employeeManagement",
  initialState,
  reducers: {
    setInActive: (state, action: PayloadAction<string>) => {
      const selectAgent = state.agents?.AgentList.find(
        (agent: IAgent) => action.payload == agent.MobileNo
      );
      if (selectAgent && selectAgent.Status === "1") selectAgent.Status = "2";
    },
    setActive: (state, action: PayloadAction<string>) => {
      const selectAgent = state.agents?.AgentList.find(
        (agent: IAgent) => action.payload == agent.MobileNo
      );
      if (selectAgent && selectAgent.Status === "2") selectAgent.Status = "1";
    },
    setRemove: (state, action: PayloadAction<string>) => {
      const selectAgent = state.agents?.AgentList.find(
        (agent: IAgent) => action.payload == agent.MobileNo
      );
      if (selectAgent) selectAgent.Status = "3";
    },
    resetEmployeeManagement: () => initialState,
    resetEmployeeManagementError: (state) => {
      state.error = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAgentsAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getAgentsAsync.fulfilled,
        (state, action: PayloadAction<IEmployeeManagementResponse>) => {
          state.loading = false;
          state.agents = action.payload;
          state.success = state.agents?.Issucceeded;
        }
      )
      .addCase(getAgentsAsync.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.error?.message;
        state.success = false;
      });
  },
});

export const {
  setInActive,
  setActive,
  setRemove,
  resetEmployeeManagement,
  resetEmployeeManagementError,
} = employeeManagementSlice.actions;

export const selectSuccess = (state: RootState) =>
  state.employeeManagement.success;
export const selectAgents = (state: RootState) =>
  state.employeeManagement.agents?.AgentList;

export default employeeManagementSlice.reducer;
